import { render, staticRenderFns } from "./SharePostDialog.vue?vue&type=template&id=706063f0"
import script from "./SharePostDialog.vue?vue&type=script&lang=js"
export * from "./SharePostDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports